/* Local dependencies */
import {
  ActionTypesUser,
  IDoctorsState,
  InterfaceUserTypes,
} from "../types/Types";

const initalStateUser: IDoctorsState = {
  error: null,
  loading: false,
  doctors: [],
  categories: [],
};

export const doctorsReducer = (
  state = initalStateUser,
  action: ActionTypesUser
): IDoctorsState => {
  switch (action.type) {
    case InterfaceUserTypes.DOCTORS_LOADER:
      return { ...state, loading: true };

    case InterfaceUserTypes.DOCTORS:
      return { ...state, ...action.payload, loading: false, error: "" };

    case InterfaceUserTypes.DOCTORS_ERROR:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
